<template>
  <div id="app" >
    <cabecalho/>
    <b-container>
       <h3 class="mt-5 mb-3">Olá {{keycloak.tokenParsed.name}}!</h3>
      <lista-certificados :cpf=keycloak.tokenParsed.cpf></lista-certificados>
      <div class="row d-flex justify-content-center m-1">
        <auto-consumo></auto-consumo>
      </div>
    </b-container>
    <rodape />
  </div>
</template>
<script>

import Rodape from "./components/Rodape.vue";
import Cabecalho from "./components/Cabecalho.vue";
import ListaCertificados from "./components/ListaCertificados.vue";
import AutoConsumo from "./components/AutoConsumo.vue"

export default {
  components: { Rodape, Cabecalho, ListaCertificados, AutoConsumo },
  name: "App",
  props: ["keycloak"],
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.container {
    min-height: 72vh;
}   

h3 {
  color: #35699c;
}
</style>
